import {Text} from '@chakra-ui/react';
import {useCartContext, useCustomerContext, useOrderContext} from 'components/providers';
import {useTranslation} from 'hooks';
import {FC} from 'react';
import ImageUI from 'ui/ImageUI';

import {Price} from '..';

export const DeliveryCostInfo: FC = () => {
  const {t} = useTranslation();
  const {customer} = useCustomerContext();
  const {cartProvider, restToFreeDelivery, deliveryDetails, cartItemsPrice, colaPromo, isColaFreeDelivery} =
    useCartContext();
  const {voucher} = useOrderContext();

  if (!cartProvider) return null;
  const customerFreeDelivery = customer.free_delivery;

  const deliveryPrice = cartProvider.delivery_price;
  let finalVal = deliveryPrice[0];
  for (let i = 0; i < deliveryPrice.length; i++) {
    const item = deliveryPrice[i];
    if (!item) continue;
    if (restToFreeDelivery < item.price_from) {
      finalVal = item;
      break;
    }
  }

  const currentDeliveryAmount = deliveryDetails?.deliveryAmount ?? 0;
  const discountPromoPrice = finalVal.price === 0 ? deliveryPrice[0].price : currentDeliveryAmount - finalVal.price;

  if (customer.month_order_count === customer.each_n_free - 1 && !(voucher && voucher.is_valid)) {
    return (
      <>
        <ImageUI src="/profile-menu/info-icon.svg" alt="icon" />
        <Text fontSize="14px" fontWeight="500" lineHeight="17px" ml="20px">
          {customer?.minimal_order_sum === 0 || customer?.minimal_order_sum === null ? (
            t('each_n_free').replace('{0}', `${customer.each_n_free}`)
          ) : (
            <>
              {t('ADD_MORE_PRODUCTS')}
              <Price value={customer.minimal_order_sum - cartItemsPrice} priceProps={{fontWeight: 'bold', mx: '5px'}} />
              {t('ADD_MORE_PRODUCTS_DESCRIPTION_FREE')}
            </>
          )}
        </Text>
      </>
    );
  }

  return (
    <>
      <ImageUI src="/profile-menu/info-icon.svg" alt="icon" />
      <Text fontSize="14px" fontWeight="500" lineHeight="17px" ml="20px">
        {t('ADD_MORE_PRODUCTS')}
        <Price value={restToFreeDelivery} priceProps={{fontWeight: 'bold', mx: '5px'}} />
        {customerFreeDelivery &&
        customer?.minimal_order_sum >= cartItemsPrice &&
        !(customer.month_order_count === customer.each_n_free - 1) ? (
          t('cartFreeDeliveryInfo')
        ) : (
          <>
            {finalVal.price === 0 || (colaPromo?.cola_promo_active && isColaFreeDelivery) ? (
              t('ADD_MORE_PRODUCTS_DESCRIPTION_FREE')
            ) : (
              <>
                {t('ADD_MORE_PRODUCTS_DESCRIPTION')}
                <Price value={discountPromoPrice} priceProps={{fontWeight: 'bold', mx: '5px'}} />
                🏷️
              </>
            )}
          </>
        )}
      </Text>
    </>
  );
};
